import { ActorSubclass, HttpAgent } from '@icp-sdk/core/agent'

// Import IDL factories from JavaScript files
import { idlFactory as c3Factory } from '../../idls/nfts/c3.did'
import { idlFactory as dip721Factory } from '../../idls/nfts/dip_721.did'
import { idlFactory as extFactory } from '../../idls/nfts/ext.did'
import { idlFactory as icpunksFactory } from '../../idls/nfts/icpunks.did'
import { idlFactory as icrc7Factory } from '../../idls/nfts/icrc_7.did'

// Import service types from TypeScript files
import C3Actor from '../../idls/nfts/c3.did'
import Dip721Actor from '../../idls/nfts/dip_721.did'
import ExtActor from '../../idls/nfts/ext.did'
import IcpunksActor from '../../idls/nfts/icpunks.did'
import Icrc7Actor from '../../idls/nfts/icrc_7.did'
import { createActor } from '../createActor'

interface NFTActor {
  c3?: ActorSubclass<C3Actor>
  dip721?: ActorSubclass<Dip721Actor>
  ext?: ActorSubclass<ExtActor>
  icpunks?: ActorSubclass<IcpunksActor>
  icrc7?: ActorSubclass<Icrc7Actor>
}

const getNftActor = (canisterId: string, standard: string, agent: HttpAgent): NFTActor => {
  switch (standard) {
    case 'C3':
      return { c3: createActor(c3Factory, { canisterId, agent }) }
    case 'DIP721':
      return { dip721: createActor(dip721Factory, { canisterId, agent }) }
    case 'EXT':
      return { ext: createActor(extFactory, { canisterId, agent }) }
    case 'ICPUNKS':
      return { icpunks: createActor(icpunksFactory, { canisterId, agent }) }
    case 'ICRC7':
      return { icrc7: createActor(icrc7Factory, { canisterId, agent }) }
    default:
      return {}
  }
}

export default getNftActor
